import React, { FunctionComponent, ReactElement } from 'react'
import cn from 'classnames'
import { Icon } from '@/icons'
import styles from './Loading.module.scss'

type LoadingProps = {
  isFullscreen?: boolean
  withText?: boolean
  className?: string
  text?: string | ReactElement
}
export const Loading: FunctionComponent<LoadingProps> = ({
  isFullscreen = false,
  withText = true,
  text = 'Защищаем ваши интересы',
  className = '',
}) => {
  return (
    <div
      className={cn(styles.container, className, {
        [styles.isFullscreen]: isFullscreen,
      })}
      data-testid="loading-container"
    >
      <div className={styles.content}>
        <Icon name="loader" className={styles.icon} />
        {withText ? <div className={styles.text}>{text}</div> : null}
      </div>
    </div>
  )
}
